import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { checkPermission } from "../../../Helper";
// import Select from "react-select";
// import ItemLoadComponent from "../../Forms/ShortCutComponents/ItemForm";
import AddWaiterComponent from "../waiters/components/addWaiter";
import "../branches/myReactSelect.css";
// import NumberFormat from "react-number-format";
import { Button, Col } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../branches/formsTable.css";
import "../branches/baseForms.css";
import axios from "axios";
import { baseurl } from "../../../baseurl";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");

let companyId = localStorage.getItem("companyId");
class Items extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    console.log(props?.location.state?.row_branch_id);
    console.log(props?.location.state?.row_branch_desc);

    this.toggleAddNew = this.toggleAddNew.bind(this);

    this.hsandleChange = this.handleChange.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);

    ////////////////////////

    this.addToggle = this.addToggle.bind(this);

    // this.table = data.rows;
    this.state = {
      showModalAddNew: false,
      data: [],
      govtDesc: "",
      govtDescE: "",
      id: "",
      permission: true,
      rolesPermission: false,
      itemAdd: "",
      showModalOpen: false,
      showItemForm: false,
      tableData: [],
      row_BranchId: "",
      isLoadedTableData: false,
      defaultSalesTaxOptions: [],
      defaultQuanShow: "0",
      defaultRateShow: "0",
      activity: props?.propData?.location?.rowData?.referencePk,
    };
    thisContex = this;
  }
  // let branchid = props.location.state.row_branch_id;
  // let branchdesc = this.props.location.state.row_branch_desc;
  showUpdateModal = (cell, row) => {
    console.log("row dekho", row);

    this.setState({
      showItemForm: !this.state.showItemForm,
      row_id: row.waiter_id,
      row_BranchId: row.branch_id,
      updateCheck: 1,
    });
    this.updateModalToggle();
  };
  updateModalToggle = () => {
    this.setState({
      UpdateModal: !this.state.UpdateModal,
    });
  };
  itemLoad = () => {
    this.setState({
      row_id: "-1",
      showItemForm: !this.state.showItemForm,
    });
    this.getData();
    // this.getLovsLoad();
  };
  setDelete = async (row) => {
    const deleteCheck = await this.asyncRollCheck(3);
    if (deleteCheck) {
      return;
    }
    let rowId = row.waiter_id;
    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/pointOfSale/getDelPosWaiter`,

            {
              Id: rowId,
              username: username,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  orderDetHandler = (cell, row) => {
    const { rolesPermission } = this.state;
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="primary"
            disabled={rolesPermission}
            onClick={() => this.showUpdateModal(cell, row)}
          >
            Edit
          </Button>
        </span>

        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            onClick={() => this.setDelete(row)}
            disabled={rolesPermission}
          >
            Delete
          </Button>
        </span>
        <span></span>
      </div>
    );
  };
  toggleAddNew = () => {
    this.setState({
      showItemForm: !this.state.showItemForm,
    });
    // this.setState({ showModalAddNew: !this.state.showModalAddNew });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  handleChange(event) {
    this.setState({
      // Computed property names
      // keys of the objects are computed dynamically
      [event.target.name]: event.target.value,
    });
  }
  handleChangeEdit(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  addToggle = () => {
    this.setState({
      itemAdd: "",
    });
    this.toggleAddNew();
  };
  showDetailsModel = (cell) => {
    this.toggleOpen();
  };
  async componentDidMount() {
    await this.asyncRollCheck(0);
    if (this.state.permission) this.getData();
  }
  asyncRollCheck = async (value) => {
    let pathname = "/waiterOverview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  getData() {
    axios
      .post(
        `${baseurl}/pointOfSale/getPosWaiter`,
        {
          companyId: companyId,
          username: username,
          brId: this.props?.location.state?.row_branch_id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let pushDataArray = [];
        // console.log(res.data.data);
        let getItemData = res.data.data;
        let statusValue;
        for (let i = 0; i < getItemData.length; i++) {
          console.log("getItemData :>> ", getItemData);

          let waiterName = getItemData[i]["waiterName"];
          let waiterType = getItemData[i]["waiterType"];
          let waiter_id = getItemData[i]["waiter_id"];
          let status = getItemData[i]["status"];
          let branchDescription = getItemData[i]["branchDescription"];
          console.log("waiterName", waiterName);
          //  let shortDesc=getItemData[i]["short_desc"];
          //  let companyDesc=getItemData[i]["COMPANY_DESC"];
          //  let creationDate=getItemData[i]["creationDate"];
          if (status == 0) {
            statusValue = "InActive";
          } else {
            statusValue = "Active";
          }
          pushDataArray.push({
            waiterName: waiterName,
            waiterType: waiterType,
            waiter_id: waiter_id,
            // "COMPANY_DESC":companyDesc,
            // "creationDate":creationDate,
            status: statusValue,
            branchDescription: branchDescription,
          });
        }
        console.log("pushDataArray :>> ", pushDataArray);
        //Storing users detail in state array object
        this.setState({
          isLoadedTableData: true,
          tableData: pushDataArray,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handleChangeLovsSelect = (defaultSalesTax) => {
    console.log(defaultSalesTax);
    this.setState({
      defaultSalesTax,
      // customerName: customer_id?.label,
      // customerEmail: customer_id?.email,
    });
  };
  handleChangeLovsSelectUom = (uom) => {
    console.log(uom);
    this.setState({
      uom,
    });
  };
  handleChangeLovsSelectUomE = (uomE) => {
    console.log(uomE);
    this.setState({
      uomE,
    });
  };
  handleChangeLovsSelectItemType = (itemType) => {
    console.log(itemType);
    this.setState({
      itemType,
    });
  };
  handleChangeLovsSelectItemTypeE = (itemTypeE) => {
    console.log(itemTypeE);
    this.setState({
      itemTypeE,
    });
  };
  // handleSubmitAddItem = (event) => {
  //   const {
  //     itemAdd,
  //     defaultDes,
  //     defaultQuan,
  //     defaultRate,
  //     defaultQuanShow,
  //     defaultRateShow,
  //     defaultSalesTax,
  //     itemType,
  //     uom,
  //   } = this.state;
  //   console.log(itemAdd);
  //   console.log(defaultDes);
  //   console.log(defaultQuan);
  //   console.log(defaultRate);
  //   console.log(defaultQuanShow);
  //   console.log(defaultRateShow);
  //   console.log(defaultSalesTax);
  //   console.log(itemType.id);
  //   console.log(uom.id);
  //   // let companyId = localStorage.getItem("companyId");
  //   event.preventDefault();

  //   axios
  //     .post(
  //       `${baseurl}/masterData/getAddItem`,
  //       {
  //         itemAdd: itemAdd,
  //         companyId: companyId,
  //         defaultDes,
  //         defaultQuan: defaultQuan.toString().replaceAll(",", ""),
  //         defaultRate: defaultRate.toString().replaceAll(",", ""),
  //         defaultQuanShow,
  //         defaultRateShow,
  //         defaultSalesTax,
  //         uom: uom.id,
  //         itemType: itemType.id,
  //       },
  //       {}
  //     )
  //     .then(function (response) {
  //       swal({
  //         title: "Saved Successfully!",
  //         text: "Item Added",
  //         icon: "success",
  //       }).then((value) => {
  //         thisContex.getData();
  //         thisContex.addToggle();
  //       });
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };
  render() {
    const { tableData, showItemForm, isLoadedTableData } = this.state;

    const options = {
      paginationShowsTotal: true,
      page: 1,
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: tableData.length,
        },
      ],
    };
    return (
      <div className="animated fadeIn">
        <>
          <div className="O-V-heading-bar">
            <div className="col-xs-8 col-md-6 mt-2">
              <strong>
                <h4>Waiter / Rider Overview</h4>
              </strong>
            </div>

            {/* <div className="col-xs-4 col-md-6 mt-1">
                <>
                  <Link to="/branchOverview" className="float-right mt-2">
                    <u className="Back-to-Overview text-dark">
                      Back to Branch Overview
                    </u>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      color="black"
                      className="bi bi-chevron-left mx-2 "
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </Link>
                </>
              </div> */}
          </div>
        </>

        <div className="animated fadeIn">
          <div className="rowStyling mt-1">
            <Col>
              <span
                style={{
                  textAlign: "right",
                  padding: "6px",
                  float: "right",
                }}
              >
                <button
                  class="btn btn-outline-success rounded-pill "
                  // disabled= {this.props?.location.state?.row_branch_desc? false : true}
                  // title={this.props?.location.state?.row_branch_desc?
                  //  ""
                  // : "your not able to add new counter please go back to branch overview"}
                  onClick={() => this.itemLoad()}
                >
                  <i class="fa fa-plus pr-2 " aria-hidden="true" />
                  Add New Waiter
                </button>
              </span>
              <div>
                {/* my main data table loaded after my 1st call by function of did mount getLeaveApplicationMain*/}
                <div>
                  {/* <h5>Branch Name : { this.props?.location.state?.row_branch_desc}</h5> */}
                  {isLoadedTableData ? (
                    <BootstrapTable
                      data={tableData}
                      striped
                      pagination
                      hover
                      search
                      tableHeaderClass="rpr_header"
                      tableBodyClass="rpr_body"
                      containerClass="rpr_container"
                      options={options}
                    >
                      <TableHeaderColumn
                        dataField="waiter_id"
                        dataAlign="center"
                        // dataFormat={indexN}
                        dataSort={true}
                        width="10%"
                      >
                        CODE
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="waiterName"
                        dataAlign="center"
                        width="10%"
                        dataSort={true}
                        isKey={true}
                      >
                        NAME
                      </TableHeaderColumn>

                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="waiterType"
                        width="10%"
                        //   dataFormat={this.orderDetHandler}
                      >
                        TYPE
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="branchDescription"
                        dataAlign="center"
                        width="10%"
                        // isKey={true}
                      >
                        BRANCH DESC
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="status"
                        width="10%"
                        //   dataFormat={this.orderDetHandler}
                      >
                        STATUS
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="ITEM_ID"
                        width="10%"
                        dataFormat={this.orderDetHandler}
                      >
                        ACTION
                      </TableHeaderColumn>
                    </BootstrapTable>
                  ) : (
                    " Loading..."
                  )}
                </div>
              </div>
            </Col>
          </div>
        </div>

        {/* model calls on Add New Button to input data for submit data */}
        {showItemForm ? (
          <>
            {console.log("hhhhh", this.state.row_BranchId)}
            <AddWaiterComponent
              toggle={this.itemLoad}
              EditData={this.state.row_id}
              // counterBranchId={this.state.row_BranchId}
            />
          </>
        ) : null}
      </div>
    );
  }
}
export default Items;
